import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import AOS from 'aos';
import 'aos/dist/aos.css';

const MainSection = () => {

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top
    AOS.init({ duration: 1000 });
    return () => {
      AOS.refresh();
    };
  }, []);


  return (
    <div>
      <div className="container-fluid ps-5 mt-5">
        <div className=" d-flex align-items-center justify-content-start gap_icons">
          <div className="text-muted font_size_icons">
            <i class="fa-brands fa-google-pay " data-aos="fade-left"></i>
          </div>
          <div className="text-muted font_size_icons">
            <i class="fa-brands fa-cc-visa" data-aos="fade-left"></i>
          </div>
          <div className="text-muted font_size_icons">
            <i class="fa-brands fa-cc-mastercard" data-aos="fade-left"></i>
          </div>

          <div className="text-muted font_size_icons">
            <i class="fa-brands fa-amazon-pay" data-aos="fade-left"></i>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 ">
            <div className="row mt-4">
              <div className="col-md-6 d-flex justify-content-center align-items-start flex-column " data-aos="fade-up">
                <div className="font_size_main  margin_card_main_one fw-bold">
                  182K<span className="flurentpink">+</span>
                </div>
                <div className="font_size_paragraph ">Loan assets</div>
              </div>
              <div className="col-md-5 p-1">
                <div className="backg_pruple box_pruplr_heigh_and_white p-3 text-black rounded-4" data-aos="fade-right">
                  <div className="d-flex justify-content-end fs-4 mb-5">01</div>
                  <div className="row">
                    <div className="col-md-9">
                      <div className="d-flex justify-content-start mb-2 font_size_paragraph_Mainsection_01 ">
                      "Loan calculator: EMI, interest, total payment for loans."
                      </div>
                    </div>
                    <div className="col-md-3 d_flex_stuff_for_arrow ">
                      <Link  to="/loancal" className=" rounded_back_button_circle   d-flex justify-content-center align-items-center">
                        <i class="fa-solid fa-arrow-right text-white fs-5 "></i>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainSection;
